import { createStore } from "solid-js/store";

export interface LoaderStore {
	loading: [string, boolean][];
}

const store = createStore<LoaderStore>(
	{
		loading: [],
	},
	{ name: "LoaderStore" },
);

export function registerLoader(key: string): void {
	setLoaderStore("loading", (loading) => [...loading, [key, true]]);
}

export function completeLoader(key: string): void {
	setLoaderStore("loading", (loading) => loading.filter(([k]) => k !== key));
}

export const loaderStore = store[0];
export const setLoaderStore = store[1];
